import React from 'react';
import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { httpGetAllUsers } from '../../Hooks/admin/admin.get.hooks';
import EntityLoader from '../../Components/LoadingPages/LoadingEntity.component';

const UsersDataProvider = ({ children }) => {
  const {
    data: users,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['users'],
    queryFn: () => httpGetAllUsers(),
    // staleTime: 5 * 60 * 1000,
    staleTime: 2 * 60 * 60 * 1000,
    retry: 5,
  });

  if (isLoading) return <EntityLoader />;
  if (isError) return <p>Error loading users data</p>;

  return children(users);
};
UsersDataProvider.propTypes = {
  children: PropTypes.func,
};

export default UsersDataProvider;
